import triggerPostbackCancel from './triggerPostbackCancel';

export default triggerPostbackCancel;
